// src/firebaseConfig.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// const firebaseConfig = {
//   apiKey: "AIzaSyC12VfzDd2uPpkZn7wHO-ebG3fgBgtq8mo",
//   authDomain: "softstake-abc75.firebaseapp.com",
//   projectId: "softstake-abc75",
//   storageBucket: "softstake-abc75.appspot.com",
//   messagingSenderId: "226454526827",
//   appId: "1:226454526827:web:3283ecaee0600ffbc04a2e",
//   measurementId: "G-W031ELCWP9",
// };

const firebaseConfig = {
  apiKey: "AIzaSyC_3TtaALNjh0mDr56ZgpH-6wd_Ac5eAXM",
  authDomain: "softstake-e1ca7.firebaseapp.com",
  projectId: "softstake-e1ca7",
  storageBucket: "softstake-e1ca7.appspot.com",
  messagingSenderId: "1080582642561",
  appId: "1:1080582642561:web:f09de18e38f249f30ae680",
  measurementId: "G-ZYWRB8MBCK",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
